// Add Case Dialog Translation - English
export default {
  dialog: {
    title: "Create Case",
  },
  form: {
    labels: {
      name: "Case Name",
      caseType: "Case Type",
      description: "Case Description",
    },
    placeholders: {
      name: "Please enter case name (required)",
      caseType: "Please select case type (required)",
      description: "Please enter case description",
    },
    rules: {
      nameRequired: "Case name is required",
      nameLength: "Length should be 1 to 20 characters",
      caseTypeRequired: "Please select case type",
      descriptionLength: "Length should be 1 to 200 characters",
    },
  },
  buttons: {
    cancel: "Cancel",
    create: "Create",
  },
  messages: {
    createSuccess: "Created successfully",
  },
};
